import { render, staticRenderFns } from "./PayStatusPanel.vue?vue&type=template&id=70a4868a"
import script from "./PayStatusPanel.vue?vue&type=script&lang=js"
export * from "./PayStatusPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports